module.exports = __webpack_public_path__ + "images/icons_v2/info-filled-291f8918.svg";